import React, { Component } from 'react';
import { Chart } from 'react-google-charts';
import { gFormatCurrency } from "../../util";
import theme from "../Theme";
import { translate } from "../../i18n/customI18nProvider";
import { cyan } from '@mui/material/colors';

const graph_colors_history = [
    theme.palette.primary.main,
    cyan[400]
];


const titleTextStyle = {
    color: theme.palette.primary.main,
    fontSize: 24,
    bold: true,
};

class ConsumptionsLineChart extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currencyCode: props.currencyCode,
            currencySymbol: props.currencySymbol,
        }
    }

    render() {
        let currency = this.state.currencySymbol ? this.state.currencySymbol : this.state.currencyCode;
        const { history } = this.props;
        const debit = [[
            translate('custom.date'),
            translate('custom.entrances'),
            translate('custom.consumptions')
        ]];
        let found = false;

        for (let i = 0; i < history.length; i++) {
            debit.push([
                new Date(history[i]["date"]),
                gFormatCurrency(history[i]["entrance"]),
                gFormatCurrency(history[i]["debit"])
            ]);
            if (history[i]["entrance"] !== 0 || history[i]["debit"] !== 0) {
                found = true;
            }
        }

        if (found) {
            let view = (
                <Chart
                    chartType="LineChart"
                    width="100%"
                    height="500px"
                    data={debit ?? []}
                    options={{
                        title: translate('custom.consumptions'),
                        titleTextStyle,
                        vAxis: {
                            title: translate('custom.amount') + ' (' + currency + ')',
                            format: 'short'
                        },
                        hAxis: {
                            format: translate('custom.OPTIONS.chart_date_time_format')
                        },
                        colors: graph_colors_history,
                        backgroundColor: { fill: 'transparent' },
                        legend: { position: 'bottom' }
                    }}
                    graph_id="ConsumptionsChart"
                />
            );
            return (
                <div>
                    {view}
                </div>
            )
        }
        return null;
    }
}

export default ConsumptionsLineChart;